// Added by Sejune Oh on 2019-06-11
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Store
import RootStore from '../..'
import MgmtStoreBase from '../../base/MgmtStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export interface APSElementProps {
    engines?: Array<APSEngineProps>
    items?: Array<APSRuleConditionProps>
}

export interface APSEngineProps {
    name: string
    display_name: string
    visible: boolean
    params: Array<APSEngineParamProps>
    retry_count?: number
    retry_interval?: number
}

export interface APSEngineParamProps {
    name?: string
    value?: string
    type?: EngineItemType
    possible_values?: string
    retry_count?: number
    retry_interval?: number
}

export interface APSRuleConditionProps {
    level?: 'STUDY' | 'SERIES'
    tag_name?: string
    tag_display_name: string
    items: Array<APSOperationProps>
}

export interface APSOperationProps {
    operation_name: 'HAS' | 'MATCHES' | 'RANGE' | 'CONTAINS' | 'REGEXP'
    value: string
    type: OperationItemType
    possible_values: string
}

type EngineItemType = 'string' | 'int' | 'bool' | 'real' | 'enum'
type OperationItemType = 'string' | 'int' | 'list' | 'date' | 'datetime'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class APSBase extends MgmtStoreBase<APSElementProps> {
    root?: RootStore

    constructor(root: RootStore) {
        super({ storeName: 'APSBase', apiUrl: 'mgmt/aps', _root: root })
        this.root = root
    }

    getConditions = async (): Promise<Array<APSRuleConditionProps>> => {
        const { items } = await super.getSingleWithoutId('/conditions')
        return items!
    }

    getEngines = async (): Promise<Array<APSEngineProps>> => {
        const { engines } = await super.getSingleWithoutId('/engines')
        return engines!
    }
}
